<template>
  <b-container fluid>
    <!-- Cabeçalho e navegação de ano -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h5>Gráficos Comerciais</h5>
      <div class="btn-group" role="group">
        <button class="btn btn-outline-secondary" @click="changeYear(-1)">
          Anterior
        </button>
        <button class="btn btn-outline-secondary disabled">
          {{ selectedYear }}
        </button>
        <button class="btn btn-outline-secondary" @click="changeYear(1)">
          Próximo
        </button>
      </div>
    </div>

    <!-- Container flexível para os dois charts -->
    <div class="row mb-4">
      <!-- Wrapper 1 -->
      <div v-if="permiteGrafico('forma-contato')" class="col-12 col-md-6 mb-4">
        <div class="chart-container">
          <ComercialChart1
            :data-inicio="dataInicio"
            :data-fim="dataFim"
          />
          </div>
      </div>
      <!-- Wrapper 2 -->
      <div v-if="permiteGrafico('como-conheceu')" class="col-12 col-md-6 mb-4">
        <div class="chart-container">
          <ComercialChart2
            :data-inicio="dataInicio"
            :data-fim="dataFim"
          />
          </div>
      </div>
    </div>
    <p v-if="!(permiteGrafico('forma-contato') || permiteGrafico('como-conheceu'))" class="text-muted">Nenhum gráfico autorizado neste grupo.</p>
  </b-container>
</template>

<script>
import { relatoriosAccess } from '@/utils/relatoriosAccess'
import { BContainer } from 'bootstrap-vue-next'
import ComercialChart1 from '@/components/Gestao/Graficos/Comerciais/ComercialChart1.vue'
import ComercialChart2 from '@/components/Gestao/Graficos/Comerciais/ComercialChart2.vue'

export default {
  name: 'ComerciaisView',
  components: {
    BContainer,
    ComercialChart1,
    ComercialChart2
  },
  data() {
    return {
      selectedYear: new Date().getFullYear()
    }
  },
  computed: {
    dataInicio() { return `${this.selectedYear}-01-01` },
    dataFim()    { return `${this.selectedYear}-12-31` }
  },
  methods: {
    permiteGrafico(key) { return relatoriosAccess(this.$globalState).grafico(key) },
    changeYear(delta) {
      this.selectedYear += delta
    },
    resetYear() {
      this.selectedYear = new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 250px;       /* altura fixa em desktop */
  max-height: 400px;
}
@media (max-width: 767px) {
  .chart-container {
    height: 300px;     /* um pouco menor em mobile */
  }
}

/* Se quiser, reduza o padding dos botões */

.btn-group .btn {
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
}

</style>
